<footer class="main-footer" [ngClass]="{ 'dev-theme': is_dev }">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-4">
                <p class="text-light">
                    Sumé &copy; {{ dt.getFullYear() }}
                    <version-modal></version-modal>
                </p>
            </div>
            <div class="col-sm-4">
                <p class="text-light text-center">
                    {{ portalService.titulo$ | async }}
                </p>
            </div>
            <div class="col-sm-4 text-right">
                <p class="text-light">
                    Desenvolvido por
                    <a (click)="certificadoViewer.open(12342)" class="external"
                        >LCCV - UFAL</a
                    >
                </p>
                <document-modal-viewer #certificadoViewer>
                </document-modal-viewer>
                <!-- Please do not remove the backlink to us unless you support further theme's development at https://bootstrapious.com/donate. It is part of the license conditions. Thank you for understanding :)-->
            </div>
        </div>
    </div>
</footer>
